import AppTitle from '@theme/components/atom/AppTitle'
import BranchBox from '@theme/components/content/BranchBox'
import BranchesList from '@theme/components/content/BranchesList'
import Breadcrumbs from '@theme/components/molecule/Breadcrumbs'
import Divider from '@theme/components/molecule/Divider'
import ImageUrlMixin from '~/mixins/ImageUrlMixin'
import LayoutBase from '@theme/components/shop/LayoutBase'
import ProductsVisited from '@theme/components/product/ProductsVisited/ProductsVisitedLazy'
import SeoMixin from '~/mixins/SeoMixin'
import UniqueSellingPoints from '@theme/components/shop/UniqueSellingPoints'

export default {
  components: {
    AppTitle,
    BranchBox,
    BranchesList,
    Breadcrumbs,
    Divider,
    LayoutBase,
    ProductsVisited,
    UniqueSellingPoints,
  },
  props: {
    branches: Array,
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: this.$t('PageBranchList.breadcrumbs.index', { website: this.$t('globals.website') }),
          path: this.localePath({ name: 'branch' }),
        },
      ],
    }
  },
  head() {
    return this.getSeoHead({ yamlKey: 'PageBranchList' })
  },
  mixins: [ImageUrlMixin, SeoMixin],
}
